import { decodeJwt } from "@/utils/decode-jwt.js";

const state = {
  isThermal: false,
  isBobbieContext: false,
  bobbieToken: null,
};

const actions = {};

const mutations = {
  setIsThermal(state, value) {
    state.isThermal = value;
  },
  setIsBobbieContext(state, value) {
    state.isBobbieContext = value;
  },
  setBobbieToken(state, token) {
    state.bobbieToken = token;
  },
};

export default {
  state,
  actions,
  mutations,
};
